import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "header__content container-fluid" }
const _hoisted_3 = { class: "header__left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "content/images/logo.svg",
    alt: ""
  })
], -1 /* HOISTED */)
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = { class: "col-form-label" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "nav__wapper__left" }
const _hoisted_12 = { class: "nav__left" }
const _hoisted_13 = ["textContent"]
const _hoisted_14 = ["textContent"]
const _hoisted_15 = {
  key: 0,
  class: "modal-menu menu-div"
}
const _hoisted_16 = { class: "dropdown-menu display-block" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["textContent"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "nav__left__clip--path" }, null, -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "nav__wapper__mid" }, null, -1 /* HOISTED */)
const _hoisted_21 = { class: "nav__wapper__right" }
const _hoisted_22 = { class: "nav__right" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "nav__wapper__right__line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nav__wapper__right__line__a" })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Setting = _resolveComponent("Setting")!
  const _component_help = _resolveComponent("help")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.flag)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createCommentVNode(" Header__left "),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, [
                    _createElementVNode("strong", {
                      textContent: _toDisplayString(_ctx.t$('header.userTitle'))
                    }, null, 8 /* PROPS */, _hoisted_7)
                  ]),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    value: _ctx.userId,
                    disabled: ""
                  }, null, 8 /* PROPS */, _hoisted_8)
                ])
              ])
            ]),
            _createCommentVNode(" Header__right "),
            _createElementVNode("div", {
              class: "header__right",
              style: {"z-index":"999"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isOpenMenu = false))
            }, [
              (!_ctx.isLoginPage && _ctx.roleId === _ctx.ROLE_LIST.root)
                ? (_openBlock(), _createElementBlock("a", _hoisted_9, [
                    _createElementVNode("i", {
                      class: "material-icons",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOpenSetting && _ctx.handleOpenSetting(...args)))
                    }, "settings")
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isOpenSetting)
                ? (_openBlock(), _createBlock(_component_Setting, { key: 1 }))
                : _createCommentVNode("v-if", true),
              _createElementVNode("a", null, [
                _createElementVNode("i", {
                  class: "material-icons-outlined",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenHelp = !_ctx.isOpenHelp))
                }, "question_mark")
              ]),
              _createVNode(_component_help, {
                isOpen: _ctx.isOpenHelp,
                onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenHelp = false))
              }, null, 8 /* PROPS */, ["isOpen"]),
              (!_ctx.isLoginPage)
                ? (_openBlock(), _createElementBlock("a", _hoisted_10, [
                    _createElementVNode("i", {
                      class: "material-icons-outlined",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logout($event)))
                    }, "logout")
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("main", null, [
      (_ctx.flag)
        ? (_openBlock(), _createElementBlock("nav", {
            key: 0,
            class: _normalizeClass(_ctx.navClassName)
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "dropdown d-flex",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeShowMenu && _ctx.changeShowMenu(...args)))
                }, [
                  _createElementVNode("i", {
                    class: "material-icons",
                    textContent: _toDisplayString(_ctx.t$('header.menu'))
                  }, null, 8 /* PROPS */, _hoisted_13),
                  _createElementVNode("span", {
                    class: "nav-title",
                    textContent: _toDisplayString(_ctx.navTitle ? _ctx.t$(`header.optionMenu.${_ctx.navTitle}`) : '')
                  }, null, 8 /* PROPS */, _hoisted_14),
                  (_ctx.isOpenMenu)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("ul", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (option) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: option.id,
                              class: _normalizeClass(["dropdown-item", { 'active': _ctx.navTitle === option.id, 'disable': !option.status }]),
                              onClick: ($event: any) => (option.status ? _ctx.chooseOption(option.id, _ctx.CLASS_NAME[option.id], $event) : '')
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["color-icon", _ctx.CLASS_NAME[option.id]])
                              }, null, 2 /* CLASS */),
                              _createElementVNode("p", {
                                textContent: _toDisplayString(_ctx.t$(`header.optionMenu.${option.id}`))
                              }, null, 8 /* PROPS */, _hoisted_18)
                            ], 10 /* CLASS, PROPS */, _hoisted_17))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _hoisted_19
              ])
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _renderSlot(_ctx.$slots, "btn-group"),
                _renderSlot(_ctx.$slots, "btn-group-history")
              ]),
              _hoisted_23
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "body")
    ])
  ], 64 /* STABLE_FRAGMENT */))
}